import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';

import axios from 'axios'
import { useStripe, useElements, CardNumberElement, CardExpiryElement, CardCvcElement } from "@stripe/react-stripe-js";

import {
    Grid,
    Input,
    InputAdornment,
    TextField,
    Button,
    Autocomplete,
    CircularProgress,
    Box,
    Select,
    MenuItem,
} from "@mui/material";
import { ReactComponent as CreditCard } from "../../../assets/icons/credit-card.svg";
import './styles.css';
import { useNavigate } from "react-router-dom";
import countries from "./country";
import { useSelector } from "react-redux";


const CmLabel = (props) => {
    const { children, ...lProps } = props;
    return (
        <label style={{ color: '#6D7280', fontSize: '14px' }} {...lProps}>{children}</label>
    );
};

const FormPago = ({ formData, handleChange, handleExpireDate }) => {
    const { t } = useTranslation(['checkout', 'components', 'paths']);
    const navigate = useNavigate();
    const stripe = useStripe();
    const elements = useElements();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);
    const lead = useSelector((state) => state.cart.checkout.travelers.mainPasseger);
    const tours = useSelector((state) => state.cart.checkout.tours);
    const [total, setTotal] = useState(0);

    const bookedTours = tours.map(tour => {
        const rates = tour.booking.map(rate => {
            return {
                paxType: rate.title,
                price: rate.price,
                currency: "EUR",
                margin: 25,
                rate_exchange: 1,
                pax_total: rate.value,
            }
        })

        const mainPasseger = {
            email: lead.email,
            name: lead.name,
            last_name: lead.lastName,
            phone: lead.phone,
        }

        return {
            slug: tour.slug,
            travel_date: tour.date,
            total: 0,
            lead: mainPasseger,
            rates: rates
        }
    });

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        const { REACT_APP_BASE_URL } = process.env
        const token = localStorage.getItem('token');


        try {
            if (!stripe || !elements) {
                throw new Error("Stripe.js no está completamente cargado.");
            }

            // 1. Crear Payment Intent en el backend
            const { data } = await axios.post(`${REACT_APP_BASE_URL}/index.php?r=api/booking/payment`, {
                amount: total * 100,
                currency: "eur"
            }, {
                headers: {
                    "Content-Type": "application/json",
                    'x-authorization-token': token
                }
            });

            // 2. Crear PaymentMethod con los elementos de tarjeta
            const cardNumberElement = elements.getElement(CardNumberElement);
            const cardExpiryElement = elements.getElement(CardExpiryElement);
            const cardCvcElement = elements.getElement(CardCvcElement);

            const cardElement = elements.getElement(CardNumberElement);

            const { error: stripeError, paymentIntent } = await stripe.confirmCardPayment(data.client_secret, {
                payment_method: {
                    card: cardElement,
                    billing_details: {
                        name: `${formData.name} ${formData.lastName}`,  // Aquí pasas los detalles de facturación
                        address: {
                            line1: formData.address,
                            country: formData.country,
                        },
                    },
                },
            });

            countries.sort((a, b) => a.name.localeCompare(b.name));

            if (stripeError) {
                console.log(stripeError);
                throw new Error(stripeError.message);
            } else {

                const { data: reply } = await axios.post(`${REACT_APP_BASE_URL}/index.php?r=api/booking`, {
                    paymentIntentId: paymentIntent.id,
                    tours: bookedTours
                }, {
                    headers: {
                        "Content-Type": "application/json",
                        'x-authorization-token': token
                    }
                });

                navigate(`/${t('booking-confirm')}/${reply.data.confirmation}`);
            }


            //  // Redirige a la página de confirmación

            setSuccess(true); // Pago exitoso
        } catch (err) {
            console.log(err)
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const sumPrices = (data) => {
            return data.reduce((total, item) => {
                const bookingTotal = item.booking.reduce((sum, bookingItem) => {
                    let price = parseFloat(bookingItem.price) || 0;
                    return sum + price * parseInt(bookingItem.value);
                }, 0);
                return total + bookingTotal;
            }, 0);
        }
        let total = sumPrices(tours);
        setTotal(total)
    }, [tours])



    return (

        <form onSubmit={handleSubmit}>



            <Grid container spacing={3}
                sx={{
                    '& .MuiInputBase-input': {
                        p: '7px 10px',
                        bgcolor: '#F9FAFB',
                        border: '1px solid #F9FAFB'
                    }
                }}
            >
                <Grid item xs={12} md={6} sx={{ display: 'grid' }}>
                    <CmLabel htmlFor="numCard">{t('stripe-card-number')}</CmLabel>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            border: '1px solid rgb(192, 192, 192)', // Aplica el borde aquí
                            borderRadius: '4px',
                            bgcolor: '#F9FAFB',
                            px: 1,
                            py: 1,
                        }}
                    >
                        <InputAdornment position="start">
                            <CreditCard style={{ width: 15, height: 15 }} />
                        </InputAdornment>
                        <Box sx={{ flex: 1 }}>
                            <CardNumberElement
                                options={{
                                    style: {
                                        base: {
                                            fontSize: "16px",
                                            color: "#000",
                                            backgroundColor: "#F9FAFB",
                                            "::placeholder": { color: "#aab7c4" },
                                            padding: "10px 0px",
                                        },
                                        invalid: {
                                            color: "#fa755a",
                                            iconColor: "#fa755a",
                                        },
                                    }
                                }}
                                onChange={(event) => {
                                    if (event.error) console.error(event.error.message);
                                }}
                            />
                        </Box>
                    </Box>
                    {/* <Input
                        startAdornment={
                            <InputAdornment position="start">
                                <CreditCard height={15} width={15} />
                            </InputAdornment>
                        }
                        sx={{
                            border: '1px solid rgb(192, 192, 192)',
                            borderRadius: '4px',
                            bgcolor: '#F9FAFB',
                            "&::before": { borderBottom: 'none!important' },
                            "&::after": { borderBottom: 'none' },
                            '& .MuiInputAdornment-root': { pl: '5px', mr: 0 },
                            '& .MuiInputBase-input': { pl: '5px' }
                        }}
                        name="numCard"
                        type="text"
                        placeholder="0000 0000 0000 0000"
                        value={formData.numCard}
                        onChange={handleChange}
                        inputProps={{ maxLength: 19 }}
                    /> */}
                </Grid>

                {/* <Grid item xs={12} md={3} sx={{ display: 'grid' }}>
                    <CmLabel htmlFor="date">Fecha vencimiento</CmLabel>
                    <TextField
                        name="date"
                        type="text"
                        placeholder="MM/YY"
                        value={formData.date}
                        onChange={handleExpireDate}
                        inputProps={{ maxLength: 5 }}
                    />
                </Grid> */}

                <Grid item xs={12} md={3} sx={{ display: 'grid' }}>
                    <CmLabel htmlFor="expiry-date">{t('stripe-card-expirationDate')}</CmLabel>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            border: '1px solid rgb(192, 192, 192)',
                            borderRadius: '4px',
                            bgcolor: '#F9FAFB',
                            px: 1,
                            py: 1,
                        }}
                    >
                        <Box sx={{ flex: 1 }}>
                            <CardExpiryElement
                                id="expiry-date"
                                options={{
                                    style: {
                                        base: {
                                            fontSize: "16px",
                                            color: "#000",
                                            "::placeholder": { color: "#aab7c4" },
                                        },
                                        invalid: {
                                            color: "#fa755a",
                                        },
                                    }
                                }}
                                onChange={(event) => {
                                    if (event.error) console.error(event.error.message);
                                }}
                            />
                        </Box>
                    </Box>
                </Grid>

                {/* <Grid item xs={12} md={3} sx={{ display: 'grid' }}>
                    <CmLabel htmlFor="cvv">CVV</CmLabel>
                    <TextField
                        name="cvv"
                        type="text"
                        placeholder="CVV"
                        value={formData.cvv}
                        onChange={handleChange}
                        inputProps={{ maxLength: 3 }}
                    />
                </Grid> */}

                <Grid item xs={12} md={3} sx={{ display: 'grid' }}>

                    <CmLabel htmlFor="cvc">{t('stripe-card-cvc')}</CmLabel>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            border: '1px solid rgb(192, 192, 192)',
                            borderRadius: '4px',
                            bgcolor: '#F9FAFB',
                            px: 1,
                            py: 1,
                        }}
                    >
                        <Box sx={{ flex: 1 }}>
                            <CardCvcElement
                                id="cvc"
                                options={{
                                    style: {
                                        base: {
                                            fontSize: "16px",
                                            color: "#000",
                                            "::placeholder": { color: "#aab7c4" },
                                        },
                                        invalid: {
                                            color: "#fa755a",
                                        },
                                    }
                                }}
                                onChange={(event) => {
                                    if (event.error) console.error(event.error.message);
                                }}
                            />
                        </Box>
                    </Box>
                </Grid>

                <Grid item xs={12} md={6} sx={{ display: 'grid' }}>
                    <CmLabel htmlFor="name">{t('stripe-card-firstName')}*</CmLabel>
                    <TextField
                        name="name"
                        type="text"
                        placeholder={t('form-placeholder')}
                        value={formData.name}
                        onChange={(e) => { handleChange(e) }}
                    />
                </Grid>

                <Grid item xs={12} md={6} sx={{ display: 'grid' }}>
                    <CmLabel htmlFor="lastName">{t('stripe-card-lastName')}*</CmLabel>
                    <TextField
                        name="lastName"
                        type="text"
                        placeholder={t('form-placeholder')}
                        value={formData.lastName}
                        onChange={handleChange}
                    />
                </Grid>

                <Grid item xs={12} md={6} sx={{ display: 'grid' }}>
                    <CmLabel htmlFor="address">{t('stripe-card-billingAddress')}*</CmLabel>
                    <TextField
                        name="address"
                        type="text"
                        placeholder={t('form-placeholder')}
                        value={formData.address}
                        onChange={handleChange}
                    />
                </Grid>

                <Grid item xs={12} md={6} sx={{ display: "grid" }}>
                    <CmLabel htmlFor="country">{t('stripe-card-country')}*</CmLabel>
                    <Select
                        labelId="country-select-label"
                        id="country-select"
                        name="country"
                        value={formData.country || ""}
                        onChange={(event) => handleChange(event)}
                    >
                        {countries.map((country) => (
                            <MenuItem key={country.code} value={country.code}>
                                {country.name}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid>

                <Grid item xs={12}>
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        disabled={loading}
                        fullWidth
                    >
                        {loading ? <CircularProgress size={24} /> : t('stripe-button-pay')}
                    </Button>
                    {error && <p style={{ color: 'red' }}>{error}</p>}
                    {success && <p style={{ color: 'green' }}>{t('stripe-pay-success')}</p>}
                </Grid>
            </Grid>
        </form>
    );
};

export default FormPago;
